import { useReducer } from "react";
import { initialState, CropsContextReducer } from "./crops-context-reducer";
import { CropsContext, CropsContextDispatch } from "./crops-context";

export const CropsContextProvider = ({ children }) => {
  const [context, dispatch] = useReducer(CropsContextReducer, initialState)

  return (
    <CropsContext.Provider value={context}>
      <CropsContextDispatch.Provider value={dispatch}>
        {children}
      </CropsContextDispatch.Provider>
    </CropsContext.Provider>
  )
}
